export const ACTIONS_MATERIAL_CLASS = {
  INVALIDATE: 'MATERIAL_CLASSES_INVALIDATE',
  RECEIVE: 'MATERIAL_CLASSES_RECEIVE',
  DELETE: 'MATERIAL_CLASS_DELETE',
  UPDATE: 'MATERIAL_CLASS_UPDATE',
};

const materialClassConstants = {};

export default materialClassConstants;
